// Controls
// Styles
import { getClassNames, virtualContainerStyles } from "./VirtualContainer.styles";
// Utilities
import React, { useCallback, useEffect, useState } from "react";
import { InView } from "react-intersection-observer";
/**
 * VirtualContainer wraps around child component (for instance User/Group) helping to lazy load data just when component is rendered
 */ export function VirtualContainer({ containerId, onLoad, children }) {
    const [, setState] = useState({
        hasLoaded: false
    });
    useEffect(()=>{
        setState({
            hasLoaded: false
        });
    }, [
        containerId
    ]);
    const handleInViewCallback = useCallback((inView)=>{
        setState((prev)=>{
            if (!prev.hasLoaded && inView) {
                onLoad();
                return {
                    hasLoaded: true
                };
            }
            return prev;
        });
    }, [
        onLoad
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "virtualContainer-wrapper"
    }, /*#__PURE__*/ React.createElement(InView, {
        onChange: handleInViewCallback,
        triggerOnce: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: getClassNames(virtualContainerStyles).anchor
    }))), children);
}
